<template lang='pug'>
div(:class='[$style[`cc-textarea`], $style[errorValue ? `has-error` : ``], $style[resetButton ? `has-resetBtn` : ``]]')

  span(v-if='errorRegex' v-html='errorRegexInfo' :class='$style[`cc-textarea-regex-error`]')

  div(v-if='emojiButton' :class='$style[`cc-textarea-emoji`]' v-on-clickaway='handleEmojiOnBlur')
    perfect-scrollbar.emoji-selector(v-show='showEmoji' :class='$style[`cc-emoji-selector`]' ref='customScrollBarDom')
      div(:class='$style[`cc-emoji-selector-wrap`]' ref='customScrollBarDom')
        div(:class='$style[`cc-selector-wrap-type`]')
          span(:class='$style[`cc-selector-wrap-category`]')!= '表情'
          ul(:class='$style[`cc-emoji-selector-ul`]')
            li(v-for='(items, index) in EMOJI.face' :key='index' :class='$style[`cc-emoji-selector-li`]' @click='handleAppendEmojiOnClick(items)') {{ items }}

        div(:class='$style[`cc-selector-wrap-type`]')
          span(:class='$style[`cc-selector-wrap-category`]')!= '人物與手勢'
          ul(:class='$style[`cc-emoji-selector-ul`]')
            li(v-for='(items, index) in EMOJI.action' :key='index' :class='$style[`cc-emoji-selector-li`]' @click='handleAppendEmojiOnClick(items)') {{ items }}

        div(:class='$style[`cc-selector-wrap-type`]')
          span(:class='$style[`cc-selector-wrap-category`]')!= '物品'
          ul(:class='$style[`cc-emoji-selector-ul`]')
            li(v-for='(items, index) in EMOJI.item' :key='index' :class='$style[`cc-emoji-selector-li`]' @click='handleAppendEmojiOnClick(items)') {{ items }}

    div(:class='[$style[`cc-textarea-emoji-switcher`], $style[!showEmoji ? `cc-no-active` : ``]]' @click='handleShowEmojiList')
      IconEmoji(v-if='showEmoji' :size='28')
      IconEmoji(v-else :size='28' :color='`#d0d0d0`')


  textarea(
    v-if='autoSize'
    v-autosize='changeValue'
    ref='texter'
    :type='type'
    :placeholder='!plhShow ? `` : plh'
    :class='[$style[`cc-textarea-area`], $style[isDisabled ? `cc-textarea-disable` : ``]]'
    :disabled='isDisabled'
    @input='onTextAreaChange($event.target.value)'
    @focus='onTextAreaFocus'
    @blur='onTextAreaBlur'
    @keypress.stop.prevent.enter='keyPressEnter'
  )

  textarea(
    v-else
    ref='texter'
    :type='type'
    :placeholder='!plhShow ? `` : plh'
    :class='[$style[`cc-textarea-area`], $style[`cc-no-autosize`], style[isDisabled ? `cc-textarea-disable` : ``]]'
    :disabled='isDisabled'
    @input='onTextAreaChange($event.target.value)'
    @focus='onTextAreaFocus'
    @blur='onTextAreaBlur'
    @keypress.stop.prevent.enter='keyPressEnter'
  )

  span(
    v-if='resetButton'
    v-show='changeValue'
    :class='$style[`cc-textarea-reset`]'
    @click='onTextAreaResetClick')
    IconClose(:size='16' :color='`#98A1A1`')

</template>

<script>
import IconClose from '../../icon/Close';
import IconEmoji from '../../icon/Emoji';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  components: {
    IconClose,
    IconEmoji,
  },

  mixins: [clickaway],

  model: {
    prop: 'changeValue',
    event: 'texter',
  },

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    keyPressEnter: {
      type: Function,
      default: function () {},
    },
    defaultValue: {
      type: String,
      default: '',
    },
    changeValue: {
      type: String,
      default: '',
    },
    resetButton: {
      type: Boolean,
      default: false,
    },
    emojiButton: {
      type: Boolean,
      default: false,
    },
    autoSize: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    errorValue: {
      type: Boolean,
      default: false,
    },
    errorRegex: {
      type: Boolean,
      default: false,
    },
    errorRegexInfo: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
  },

  data() {
    return {
      plh: this.placeholder,
      plhShow: true,
      showEmoji: false,
      isTextAreaGetValue: false,
      // nextTick: 1,
    };
  },

  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.inputer.value = this.defaultValue;
    // })
    this.$refs.texter.value = this.defaultValue;
  },

  methods: {
    forceResetValue() {
      this.$refs.texter.value = '';
    },

    onTextAreaResetClick() {
      this.$emit('texter', '');
      this.$refs.texter.value = '';
    },

    onTextAreaChange(newValue) {
      // console.log('Input SearchBar onChange!!!', newValue);
      newValue ? this.isTextAreaGetValue = true : this.isTextAreaGetValue = false;
      this.$emit('texter', newValue);
      this.$emit('clearErrorMsg', [false, false]);
    },

    onTextAreaFocus() {
      if (this.isDisabled) { return; }
      this.plhShow = false;
    },

    onTextAreaBlur() {
      if (this.isDisabled) { return; }
      this.plhShow = true;
    },

    // Emoji
    handleEmojiOnBlur() {
      this.showEmoji = false;
    },

    handleShowEmojiList() {
      this.showEmoji = !this.showEmoji;
    },

    handleAppendEmojiOnClick(emoji) {
      this.$refs.texter.value = this.$refs.texter.value + emoji;
      this.$emit('texter', this.$refs.texter.value);
      // this.nextTick += 1;
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/common/textarea.scss';
</style>
